<template>
    <div class="text-center" style="margin-top:40vh">
      <h2>403</h2>
      <p>brak uprawnień</p>
      <v-btn color="primary" depressed @click.native="$router.push({ path: '/' })">Powrót</v-btn>
  </div>
</template>
<script>
export default {
  name: 'Forbidden'
}
</script>
